import React from 'react';

import {
  APP_BACK,
  APPLE_SMALL,
  ARROW_DOWN,
  ARROW_UP,
  AUTO_OPEN,
  BACK,
  BLUE_ALERT,
  BLUE_CHECK,
  BLUE_CHECK_CIRCLE,
  BOT,
  BOX_STAR,
  CELEBRATE,
  CELEBRATION,
  CHEVRON_RIGHT_SMALL,
  CircleStarGray, CLOSE,
  CLOSE_BLACK,
  CLOSE_BLACK_SMALL,
  CLOSE_SMALL,
  COIN,
  COINS,
  COLORD_GIFT,
  COMMUNITY,
  COMPANY,
  COMPASS,
  COMPOSE,
  COPY,
  CREDIT_CARD,
  CREDIT_LIMIT,
  DASHBOARD,
  DASHBOARD_BLUE,
  DEFAULT_COMPANY_BIG,
  DISC,
  DOWN,
  DOWN_BLACK,
  DOWN_CHEVRON,
  EMPTY_LIST,
  ENRICH,
  ENRICH_HOVER,
  ENRICH_PRESSED,
  ERROR,
  EXTERNAL_GRAY_SMALL,
  EXTERNAL_LINK,
  FACEBOOK,
  FAIL_INDICATION,
  FEEDBACK_DEFAULT,
  FILTER,
  FILTERV2,
  FLAG,
  FLASHLIGHT,
  FREE_CREDITS,
  FREE_CREDITS_HOVER,
  FREE_CREDITS_PRESSED,
  FULL_LIST,
  FUNDING,
  GIFT,
  GLASSES,
  GLOBE,
  GLOBE_BLACK,
  GLOBE_BLUE,
  GMAIL,
  GMAIL_SIGNUP,
  GMAILV2,
  GOOGLE,
  GRAPH,
  HAND_SNAP,
  HELP,
  HISTORY_TAB,
  HISTORY_TAB_HOVER,
  HISTORY_TAB_PRESSED,
  HOURGLASS,
  IDLE,
  INDUSTRY,
  INFO,
  INFO_BLUE,
  INFO_FULL,
  INFO_STROKE,
  INTERCOM,
  INTERCOMSMALL,
  INVITE,
  LEFT,
  LIGHT_BULB,
  LIMIT_EXCEEDED,
  LINKEDIN,
  LINKEDIN_BLUE,
  LISTS,
  LOCATION,
  LUSHA,
  LUSHA_SCOUT_UPPER,
  MAGNIFYING_GLASS,
  MAIL,
  MAIL_BLACK,
  MICROSOFT_SMALL,
  MINIMIZE,
  MORE,
  MORE_HORIZONTAL,
  MORE_HOVER,
  MORE_PRESSED,
  MORE_RESULTS,
  NO_ENTRY,
  NO_PHONE,
  ONBOARDING,
  OUTER_LINK,
  OUTLOOK,
  PEOPLE,
  PLUG,
  PLUGIN_POSITION,
  PROFILE,
  PROSPECT,
  PROSPECT_HOVER,
  PROSPECT_PRESSED,
  REFER,
  REFRESH,
  REMOVE,
  REVEALED_TAG,
  RIGHT,
  RIGHT_ARROW,
  RIGHT_GRAY,
  RIGHT8X8,
  SAVE_MARK,
  SAVED_TAB,
  SAVED_TAB_HOVER,
  SAVED_TAB_PRESSED,
  SAVED_TAG,
  SCROLL,
  SEARCH,
  SEARCH_GRAY,
  SEARCH_HOVER,
  SEARCH_MORE_MENU,
  SEARCH_PRESSED,
  SEARCH_TOOLTIP,
  SEND,
  SETTINGS,
  SHEET,
  SLACK_SMALL,
  SOCIALS,
  STAR,
  SUCCESS_INDICATION,
  SUSPENDED,
  TAG_CONTACT,
  THUMBS_DOWN,
  THUMBS_DOWN_CHOSEN,
  THUMBS_UP,
  THUMBS_UP_CHOSEN,
  TIP,
  TWITTER,
  UP_CHEVRON,
  USER,
  WALLET_WARNING_SIGN,
  WEB,
  XPAPER } from './iconsLinks';
import New from './New.svg';

export const IconFactory = icon => {
  switch (icon) {
    // Header Icons
    case 'Minimize':
      return <img src={MINIMIZE} alt="Minimize" />;
    case 'Close':
      return <img src={CLOSE} alt="Close" />;
    case 'Gift':
      return <img src={GIFT} alt="Gift" />;
    case 'User':
      return <img src={USER} alt="User" />;
    case 'Mail':
      return <img src={MAIL} alt="Mail" />;
    case 'AppBack':
      return <img src={APP_BACK} alt="AppBack" />;
    case 'CloseBlack':
      return <img src={CLOSE_BLACK} alt="CloseBlack" />;
    case 'CloseBlackSmall':
      return <img src={CLOSE_BLACK_SMALL} alt="CloseBlackSmall" />;

    // Footer Icons
    case 'Enrich':
      return <img src={ENRICH} alt="Enrich" />;
    case 'EnrichHover':
      return <img src={ENRICH_HOVER} alt="Enrich Hover" />;
    case 'EnrichPressed':
      return <img src={ENRICH_PRESSED} alt="Enrich Pressed" />;
    case 'Prospect':
      return <img src={PROSPECT} alt="Prospect" />;
    case 'ProspectHover':
      return <img src={PROSPECT_HOVER} alt="ProspectHover" />;
    case 'ProspectPressed':
      return <img src={PROSPECT_PRESSED} alt="ProspectPressed" />;
    case 'More':
      return <img src={MORE} alt="More" />;
    case 'MoreHover':
      return <img src={MORE_HOVER} alt="MoreHover" />;
    case 'MorePressed':
      return <img src={MORE_PRESSED} alt="MorePressed" />;
    case 'FreeCredits':
      return <img src={FREE_CREDITS} alt="FreeCredits" />;
    case 'FreeCreditsHover':
      return <img src={FREE_CREDITS_HOVER} alt="FreeCreditsHover" />;
    case 'FreeCreditsPressed':
      return <img src={FREE_CREDITS_PRESSED} alt="FreeCreditsPressed" />;
    case 'Search':
      return <img src={SEARCH} alt="Search" />;
    case 'SearchPressed':
      return <img src={SEARCH_PRESSED} alt="Search Pressed" />;
    case 'SearchHover':
      return <img src={SEARCH_HOVER} alt="Search Hover" />;
    case 'SearchTooltip':
      return <img src={SEARCH_TOOLTIP} alt="Search Tooltip" />;

    // More Menu Icons
    case 'Help':
      return <img src={HELP} alt="Help" />;
    case 'Invite':
      return <img src={INVITE} alt="Invite" />;
    case 'Lists':
      return <img src={LISTS} alt="Lists" />;
    case 'Plug':
      return <img src={PLUG} alt="Plug" />;
    case 'AutoOpen':
      return <img src={AUTO_OPEN} alt="AutoOpen" />;
    case 'Dashboard':
      return <img src={DASHBOARD} alt="Dashboard" />;
    case 'OuterLink':
      return <img src={OUTER_LINK} alt="OuterLink" />;
    case 'Refer':
      return <img src={REFER} alt="Refer" />;
    case 'Settings':
      return <img src={SETTINGS} alt="Settings" />;
    case 'PluginPosition':
      return <img src={PLUGIN_POSITION} alt="PluginPosition" />;
    case 'GlobeBlack':
      return <img src={GLOBE_BLACK} alt="GlobeBlack" />;
    case 'SearchMoreMenu':
      return <img src={SEARCH_MORE_MENU} alt="SearchMoreMenu" />;
    case 'Community':
      return <img src={COMMUNITY} alt="Community" />;
    case 'Profile':
      return <img src={PROFILE} alt="Profile" />;

    // Contact details Icons
    case 'FeedbackDefault':
      return <img src={FEEDBACK_DEFAULT} alt="Feedback Default" />;
    case 'ThumbsDown':
      return <img src={THUMBS_DOWN} alt="Thumbs Down" />;
    case 'ThumbsUp':
      return <img src={THUMBS_UP} alt="Thumbs Up" />;
    case 'ThumbsDownChosen':
      return <img src={THUMBS_DOWN_CHOSEN} alt="Thumbs Down Chosen" />;
    case 'ThumbsUpChosen':
      return <img src={THUMBS_UP_CHOSEN} alt="Thumbs Up Chosen" />;
    case 'Copy':
      return <img src={COPY} alt="Copy" />;
    case 'DownBlack':
      return <img src={DOWN_BLACK} alt="Down Black" />;
    case 'SearchGray':
      return <img src={SEARCH_GRAY} alt="Search Gray" />;
    case 'ExternalGraySmall':
      return <img src={EXTERNAL_GRAY_SMALL} alt="External Gray Small" />;
    case 'NoPhone':
      return <img src={NO_PHONE} alt="No Phone" />;
    case 'noEntry':
      return <img src={NO_ENTRY} alt="No Entry" />;

    // Company Data Icons
    case 'Info':
      return <img src={INFO} alt="Info" />;
    case 'InfoFull':
      return <img src={INFO_FULL} alt="Info Full" />;
    case 'InfoStroke':
      return <img src={INFO_STROKE} alt="Info Stroke" />;
    case 'People':
      return <img src={PEOPLE} alt="People" />;
    case 'Industry':
      return <img src={INDUSTRY} alt="Industry" />;
    case 'Flag':
      return <img src={FLAG} alt="Flag" />;
    case 'Graph':
      return <img src={GRAPH} alt="Graph" />;
    case 'Location':
      return <img src={LOCATION} alt="Location" />;
    case 'Globe':
      return <img src={GLOBE} alt="Globe" />;
    case 'Socials':
      return <img src={SOCIALS} alt="Socials" />;
    case 'Facebook':
      return <img src={FACEBOOK} alt="Facebook" />;
    case 'Twitter':
      return <img src={TWITTER} alt="Twitter" />;
    case 'Linkedin':
      return <img src={LINKEDIN} alt="Linkedin" />;
    case 'Web':
      return <img src={WEB} alt="Web" />;
    case 'Company':
      return <img src={COMPANY} alt="Company" />;
    case 'Glasses':
      return <img src={GLASSES} alt="Glasses" />;
    case 'Back':
      return <img src={BACK} alt="Back" />;
    case 'Down':
      return <img src={DOWN} alt="Down" />;
    case 'Idle':
      return <img src={IDLE} alt="Idle" />;
    case 'Lusha':
      return <img src={LUSHA} alt="Lusha" />;
    case 'Google':
      return <img src={GOOGLE} alt="Google" />;
    case 'Intercom':
      return <img src={INTERCOM} alt="Intercom" />;
    case 'AppleSmall':
      return <img src={APPLE_SMALL} alt="Apple Small" />;
    case 'IntercomSmall':
      return <img src={INTERCOMSMALL} alt="Intercom Small" />;
    case 'MicrosoftSmall':
      return <img src={MICROSOFT_SMALL} alt="Microsoft Small" />;
    case 'SlackSmall':
      return <img src={SLACK_SMALL} alt="Slack Small" />;
    case 'funding':
      return <img src={FUNDING} alt="funding small" />;

    // Notifications
    case 'SuccessIndication':
      return <img src={SUCCESS_INDICATION} alt="Success Indication" />;
    case 'FailIndication':
      return <img src={FAIL_INDICATION} alt="Fail Indication" />;
    case 'BlueFailIndication':
      return <img src={BLUE_ALERT} alt="Blue Alert Indication" />;
    case 'InfoIndication':
      return <img src={INFO_BLUE} alt="Info Blue" />;
    case 'Remove':
      return <img src={REMOVE} alt="Remove" />;

    // Compose
    case 'Coin':
      return <img src={COIN} alt="Coin" />;
    case 'Gmail':
      return <img src={GMAIL} alt="Gmail" />;
    case 'GmailV2':
      return <img src={GMAILV2} alt="GmailV2" />;
    case 'Outlook':
      return <img src={OUTLOOK} alt="Outlook" />;
    case 'MoreHorizontal':
      return <img src={MORE_HORIZONTAL} alt="More Horizontal" />;
    case 'Send':
      return <img src={SEND} alt="Send" />;
    case 'Left':
      return <img src={LEFT} alt="Left" />;
    case 'Compose':
      return <img src={COMPOSE} alt="Compose" />;

    // Integrations
    case 'SaveMark':
      return <img src={SAVE_MARK} alt="Save Mark" />;
    case 'SavedTab':
      return <img src={SAVED_TAB} alt="Saved Tab" />;
    case 'SavedTabPressed':
      return <img src={SAVED_TAB_PRESSED} alt="Saved Tab Pressed" />;
    case 'SavedTabHover':
      return <img src={SAVED_TAB_HOVER} alt="Saved Tab Hover" />;
    case 'EmptyList':
      return <img src={EMPTY_LIST} alt="Empty List" />;
    case 'historyTabHover':
      return <img src={HISTORY_TAB_HOVER} alt="history Tab Hover" />;
    case 'historyTabPressed':
      return <img src={HISTORY_TAB_PRESSED} alt="history Tab pressed" />;
    case 'historyTab':
      return <img src={HISTORY_TAB} alt="history Tab" />;

    // Account Suspence
    case 'Suspended':
      return <img src={SUSPENDED} alt="Suspended" />;
    case 'LimitExceeded':
      return <img src={LIMIT_EXCEEDED} alt="LimitExceeded" />;
    case 'CreditCard':
      return <img src={CREDIT_CARD} alt="CreditCard" />;
    case 'Hourglass':
      return <img src={HOURGLASS} alt="Hourglass" />;

    // Maintenance
    case 'Refresh':
      return <img src={REFRESH} alt="Refresh" />;

    // Out of Credits
    case 'CreditLimit':
      return <img src={CREDIT_LIMIT} alt="CreditLimit" />;
    case 'WalletWarningSign':
      return <img src={WALLET_WARNING_SIGN} alt="WalletWarningSign" />;

    // Onboarding
    case 'Onboarding':
      return <img src={ONBOARDING} alt="Onboarding" />;
    case 'MagnifyingGlass':
      return <img src={MAGNIFYING_GLASS} alt="Magnifying Glass" />;

    // Error Boundary
    case 'Error':
      return <img src={ERROR} alt="Error" />;

    // Bot detection
    case 'Bot':
      return <img src={BOT} alt="Bot" />;

    // Prospecting
    case 'FlashLight':
      return <img src={FLASHLIGHT} alt="Flash Light" />;
    case 'DefaultCompanyBig':
      return <img src={DEFAULT_COMPANY_BIG} alt="Default Company Big" />;
    case 'Filter':
      return <img src={FILTER} alt="Filter" />;
    case 'FilterV2':
      return <img src={FILTERV2} alt="FilterV2" />;
    case 'MoreResults':
      return <img src={MORE_RESULTS} alt="MoreResults" />;
    case 'Revealed':
      return <img src={REVEALED_TAG} alt="Revealed" />;
    case 'Saved':
      return <img src={SAVED_TAG} alt="Saved" />;

    // Bulk
    case 'Scroll':
      return <img src={SCROLL} alt="Scroll" />;
    case 'ExternalLink':
      return <img src={EXTERNAL_LINK} alt="External Link" />;

    // Toolbar
    case 'DashboardBlue':
      return <img src={DASHBOARD_BLUE} alt="Dashboard Blue" />;
    case 'LinkedinBlue':
      return <img src={LINKEDIN_BLUE} alt="Linkedin Blue" />;
    case 'GlobeBlue':
      return <img src={GLOBE_BLUE} alt="Globe Blue" />;
    case 'GmailSignup':
      return <img src={GMAIL_SIGNUP} alt="Gmail Signup" />;

    // FreeTrialStarted
    case 'Compass':
      return <img src={COMPASS} alt="Compass" />;
    case 'Disc':
      return <img src={DISC} alt="Disc" />;
    case 'Sheet':
      return <img src={SHEET} alt="Sheet" />;

    // Refer a friend
    case 'BoxStar':
      return <img src={BOX_STAR} alt="Box Star" width={74} height={74} />;
    case 'MailBlack':
      return <img src={MAIL_BLACK} alt="Mail Black" />;
    case 'Celebration':
      return <img src={CELEBRATION} alt="Celebration" width={74} />;

    // Arrows and Chevrons
    case 'Right8x8':
      return <img src={RIGHT8X8} alt="Right" />;
    case 'ArrowUp':
      return <img src={ARROW_UP} alt="Arrow Up" />;
    case 'ArrowDown':
      return <img src={ARROW_DOWN} alt="Arrow Down" />;
    case 'ChevronRightSmall':
      return <img src={CHEVRON_RIGHT_SMALL} alt="Chevron Right Small" />;
    case 'Right':
      return <img src={RIGHT} alt="Right" />;
    case 'RightGray':
      return <img src={RIGHT_GRAY} alt="Right Gray" />;
    case 'UpChevron8x8':
      return <img src={UP_CHEVRON} alt="Up Chevron" />;
    case 'DownChevron8x8':
      return <img src={DOWN_CHEVRON} alt="Down Chevron" />;
    case 'RightArrow':
      return <img src={RIGHT_ARROW} alt="Right Arrow" />;

    // Miscellaneous
    case 'LushaScoutUpper':
      return <img src={LUSHA_SCOUT_UPPER} alt="Lusha Scout Upper" />;
    case 'XPaper':
      return <img src={XPAPER} alt="XPaper" />;
    case 'LightBulb':
      return <img src={LIGHT_BULB} alt="Light Bulb" />;
    case 'New':
      return <New />;
    case 'HandSnap':
      return <img src={HAND_SNAP} alt="HandSnap" />;
    case 'InfoBlue':
      return <img src={INFO_BLUE} alt="InfoBlue" />;
    case 'Celebrate':
      return <img src={CELEBRATE} alt="Celebrate" />;
    case 'Tip':
      return <img src={TIP} alt="Tip" />;
    case 'CloseSmall':
      return <img src={CLOSE_SMALL} alt="CloseSmall" />;
    case 'FullList':
      return <img src={FULL_LIST} alt="FullList" />;
    case 'Star':
      return <img src={STAR} alt="Star" />;
    case 'BlueCheck':
      return <img src={BLUE_CHECK} alt="BlueCheck" />;
    case 'BlueCheckWithCircle':
      return <img src={BLUE_CHECK_CIRCLE} alt="BlueCheckWithCircle" />;
    case 'Coins':
      return <img src={COINS} alt="Coins" />;
    case 'ColoredGift':
      return <img src={COLORD_GIFT} alt="ColoredGift" />;

    // Tags
    case 'TagContact':
      return <img src={TAG_CONTACT} alt="TagContact" height={40} width={40} />;

    // Credit
    case 'Credit':
      return <img src={CircleStarGray} alt="Credit" />;

    default:
      return null;
  }
};
